import type { MailFolder } from "@/lib/types/mail";

/** Décodage Modified UTF-7 (RFC 3501) pour libellés IMAP en cache. */
export function decodeImapMutf7(text: string): string {
  if (!text.includes("&")) return text;

  let output = "";
  let i = 0;

  while (i < text.length) {
    if (text[i] !== "&") {
      output += text[i++];
      continue;
    }

    i += 1;
    if (i >= text.length) break;

    if (text[i] === "-") {
      output += "&";
      i += 1;
      continue;
    }

    let b64 = "";
    while (i < text.length && text[i] !== "-") {
      b64 += text[i++];
    }
    if (i < text.length) i += 1;

    try {
      const normalized = b64.replace(/,/g, "/");
      const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
      const binary = atob(padded);
      for (let j = 0; j < binary.length; j += 2) {
        const hi = binary.charCodeAt(j);
        const lo = j + 1 < binary.length ? binary.charCodeAt(j + 1) : 0;
        output += String.fromCharCode((hi << 8) | lo);
      }
    } catch {
      output += `&${b64}-`;
    }
  }

  return output;
}

const FOLDER_LABELS: Record<string, string> = {
  INBOX: "Boîte de réception",
  SENT: "Envoyés",
  DRAFTS: "Brouillons",
  DRAFT: "Brouillons",
  BROUILLONS: "Brouillons",
  TRASH: "Corbeille",
  DELETED: "Corbeille",
  JUNK: "Indésirables",
  SPAM: "Indésirables",
  ARCHIVE: "Archives",
  ÉLÉMENTS_ENVOYÉS: "Envoyés",
  ELEMENTS_ENVOYES: "Envoyés",
  ÉLÉMENTS_SUPPRIMÉS: "Éléments supprimés",
  ELEMENTS_SUPPRIMES: "Éléments supprimés",
  ÉLÉMENTS_INDÉSIRABLES: "Indésirables",
  ELEMENTS_INDESIRABLES: "Indésirables",
  COURRIER_INDÉSIRABLE: "Indésirables",
  ÉLÉMENTS_SAUVEGARDÉS: "Archives",
};

function folderLabelKey(name: string): string {
  return name.toUpperCase().replace(/[\s.\-/]+/g, "_");
}

export function humanizeFolderLabel(name: string, label: string): string {
  const decoded = decodeImapMutf7(label.includes("&") ? label : name);
  const leaf = decoded.includes(".")
    ? decoded.slice(decoded.lastIndexOf(".") + 1)
    : decoded.includes("/")
      ? decoded.slice(decoded.lastIndexOf("/") + 1)
      : decoded;

  return FOLDER_LABELS[folderLabelKey(leaf)] ?? FOLDER_LABELS[folderLabelKey(decoded)] ?? decoded;
}

export function normalizeMailFolderLabels(folders: MailFolder[]): MailFolder[] {
  return folders.map((folder) => ({
    ...folder,
    label: humanizeFolderLabel(folder.name, folder.label),
  }));
}
